import { user_profile_url } from 'mk/urls/functions';
import { timeAt } from 'mk2/helpers/timeformat';
import { interpolate } from 'mk2/services/i18n';
import * as React from 'react';
import styles from './AnnouncementBox.mscss';

export const BoxType = {
    Deleted: 'deleted' as 'deleted',
    DeletedMessage: 'deletedMessage' as 'deletedMessage',
    Yellow: 'yellow' as 'yellow',
};
export type BoxType = (typeof BoxType)[keyof typeof BoxType];

interface OwnProps {
    message: string;
    detailMessage?: string;
    hasDetailMessage: boolean;
    deletedAt?: string;
    icon?: string;
    deletedBy?: string;
    type: BoxType;
    reasonValue?: string;
}

const AnnouncementBox: React.StatelessComponent<OwnProps> = ({ icon, message, detailMessage, hasDetailMessage, deletedBy, type, deletedAt, reasonValue }) => (
    <div className={styles.AnnouncementBox}>
        <div className={styles['AnnouncementBox--type-' + type]}>
            <div className={styles['AnnouncementBox__messageWrapper--type-' + type]}>
                {icon && (
                    <div className={styles['AnnouncementBox__icon--type-' + type]}>
                      <i className={icon} />
                    </div>
                )}
                <div className={styles['AnnouncementBox__message--type-' + type]}>
                    {message}
                    {deletedBy && (
                        <span>&nbsp;(
                            <a
                                className={styles.AnnouncementBox__deletedBy}
                                href={user_profile_url(deletedBy)}
                            >
                                {deletedBy}
                            </a>)
                        </span>
                    )}
                </div>
            </div>
            {hasDetailMessage && detailMessage && !deletedAt && (
                <div className={styles['AnnouncementBox__detailMessage--type-' + type]}>
                    {detailMessage}
                </div>
            )}
            {hasDetailMessage && detailMessage && deletedAt && (
                <div className={styles['AnnouncementBox__detailMessage--type-' + type]}>
                    {interpolate(reasonValue, { reason: detailMessage })}
                    <div>{timeAt(deletedAt)}</div>
                </div>
            )}
        </div>
    </div>
);

export default AnnouncementBox;
